import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { NavLink, Outlet } from "react-router-dom";

const StyledNavLink = styled(NavLink)(({ theme }) => ({
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    fontWeight: 700,
    fontSize: '1.25rem',
    // paddingBottom: '0.5rem',
    color: theme.palette.text.secondary,
    '&:hover': {
        color: theme.palette.primary.main,
    },
    '&.active': {
        color: theme.palette.primary.main,
        borderBottom: `3px solid ${theme.palette.primary.main}`,
    }
}));

const Location = () => {

    return (
        <Box sx={{
            bgcolor: 'background.default',
            color: 'text.primary',
            minHeight: '100vh',
            p: 3,
            pl:0
        }}>
            <Box
                sx={{
                    mb: 2,
                    ml: 2,
                    display: 'flex',
                    gap: 2,
                }}
            >
                <StyledNavLink to="/location" end>
                   Location Overview
                </StyledNavLink>
                <StyledNavLink to="/location/country">
                    Country List
                </StyledNavLink>
                <StyledNavLink to="/location/ip-address" end>
                   IP Overview
                </StyledNavLink>
                <StyledNavLink to="/location/ip-address/list">
                    IP Address List
                </StyledNavLink>
            </Box>

            {/* Render child routes here */}
            <Outlet />
        </Box>
    );
};

export default Location;
